import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Form               from 'app/components/forms/form';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';

import ProgramProfile from 'app/components/grant-system/program-profile';
import GrantSysDuck from 'app/ducks/grants-system';


class PageGrantProgram extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {program, myApps} = this.props;
    const title = program?.title || 'Grant Program';
    const existingAppIds = (myApps || []).filter(app => app.grantProgramId === program?.id).map(app => app.id);

    return (
      <MainLayout className="page-form">
        <Meta title={`${title} | Millie`} />
        {!!program && <ProgramProfile program={program} existingAppIds={existingAppIds} />}
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  program: GrantSysDuck.Slx.pathProgram(state),
  myApps: GrantSysDuck.Slx.myApps(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageGrantProgram);
